import {addBrowserSideAppHeaders} from '@/utils/unityHeaders';
import AppsFlyerUtils from './AppsFlyerUtils';
import {fetchWithRetry} from '@/utils/fetchWithRetry';

export default async function loginUserWithPhone(phone: string, code: string, gid: string) {
  const headers = {};
  await addBrowserSideAppHeaders(headers);
  headers['User-Agent'] = navigator.userAgent;

  const res = await fetchWithRetry('/api/login/phone', {
    method: 'POST',
    body: JSON.stringify({phone, code, gid}),
    headers,
  });
  AppsFlyerUtils.sendIdentityLink();
  return await res.json();
}
